<ng-container *ngFor="let reactionType of uniqueReactionTypes| keyvalue: valueLengthDescOrder">
  <app-reaction-emoji [reactedWith]="reactionType.key" [size]="16"></app-reaction-emoji>
</ng-container>
